import { components } from "react-select";
import { GuiButton } from "./gui-button";

export function CustomMenuList(props) {
  return (
    <components.MenuList {...props}>
      {props.children}
      <div
        style={{
          padding: "10px",
          textAlign: "center",
        }}
      >
        <GuiButton
          //  className="add-btn"
          className="btn-outline"
          onClick={(e) => {
            e.stopPropagation(); // Prevent dropdown from closing
            props.selectProps.onCustomType(); // Call the custom handler
          }}
        >
          + Add Custom Contact
        </GuiButton>
      </div>
    </components.MenuList>
  );
}
